import React from 'react';

/**
 * Logo Component
 * Renders a simple logo or header for the application.
 * In this case, the logo is represented as a header with emojis to symbolize travel.
 */
export default function Logo() {
	// Returns a heading element with travel-themed emojis
	return <h1> ⛷️ Travel List 🏄🏼‍♂️</h1>;
}
